import React from 'react';
import { FormField } from '../../../components/Form/FormField';
import { Button } from '../../../components/Button/Button';
import '../Form.css';

const SubmitaNewSpot: React.FC = () => {
  return (
    <div className="request-contact">
      <div className="main">
        <div className="header">
          <h2>Submit a New Spot</h2>
          <p>
            <b>
                Register your data and your new spot will be reviewed and added as soon as possible
            </b>
          </p>
        </div>
        
        <form className="contact-form">
          <div className="inputs">
            <FormField type="input" label="Name of a spot *" data="Spot Name" placeholder="Spot Name..." />
            <FormField type="dropdown" label="Category *" data="Category" options={[
              { value: '', label: 'Select an option' },
              { value: 'Restaurant', label: 'Restaurant' },
              { value: 'Cafe', label: 'Cafe' },
              { value: 'Pharmacy', label: 'Pharmacy' },
              { value: 'Dry Clean', label: 'Dry Clean' },
              { value: 'Supermarket', label: 'Supermarket' },
            ]} />
            <FormField type="input" label="Phone Number *" data="Phone Number" placeholder="Phone Number..." />
            <FormField type="input" label="Address *" data="Address" placeholder="Address..." />
            <FormField type="input" label="Website" data="Website" placeholder="Website..." />
            <FormField type="input" label="Fanpage" data="Fanpage" placeholder="Fanpage..." />
            <FormField type="input" label="Instagram" data="Instagram" placeholder="Instagram..." />
            <FormField type="input" label="LinkedIn" data="LinkedIn" placeholder="LinkedIn..." />
            <FormField type="upload" label="Images" data="Images" />
          </div>
          
          <Button variant="primary" label="Submit" href="#"/>
        </form>
      </div>
    </div>
  );
};

export default SubmitaNewSpot;